$(document).ready(function () {
    if ($('a.close-sticky-alert').length > 0) {
        var showId = $('.sticky-alert').data('showid').toString();
        var cookieName = 'seenalerts';
        var cookie = getCookie(cookieName);
        var cookieList = cookie == '' ? [] : cookie.split(',');

        if (showId == '') {
            return;
        }
                
        // show alert if the showId is not in the cookie
        if (cookieList.indexOf(showId) == -1) {
            $('.sticky-alert').removeClass('d-none');

            $('a.close-sticky-alert, a.buy-btn').click(function () {
                $('.sticky-alert').addClass('d-none');

                //exception for cookie if its a general announcement (id is 000)
                if (showId === '000') {
                    return;
                }

                cookieList.push(showId);
                var cookieStr = cookieList.join();
                setCookie(cookieName, cookieStr, 1000);
            });
        }
    }

    function setCookie(name, value, exdays) {
        var d, expires;
        exdays = exdays || 1;
        d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = "expires=" + d.toUTCString();
        console.log('expires: ' + expires);
        document.cookie = name + "=" + value + "; " + expires;
    }

    function getCookie(name) {
        var cookie, c;
        cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            c = cookies[i].split('=');
            if (c[0] == name) {
                return c[1];
            }
        }
        return '';
    }
})
